#import "../fragments/aiChatFragments.graphql"

mutation upsertAIChat($input: UpsertAIChatInput!) {
  chat: upsertAIChat(input: $input) {
    id
    createdAt
    updatedAt
    messages {
      ...AIChatMessageFragment
    }
  }
}

mutation upsertAIChatMessage($input: UpsertAIChatMessageInput!) {
  message: upsertAIChatMessage(input: $input) {
    ...AIChatMessageFragment
  }
}

mutation updateAIChatMessageFeedback(
  $input: UpdateAIChatMessageFeedbackInput!
) {
  message: updateAIChatMessageFeedback(input: $input) {
    id
    feedbackRating
    feedbackComment
  }
}
